// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

// export const environment = {
//     apiUrl: 'http://localhost:3420/crm', // 'http://api.akashicsoft.com/crm',  //'http://13.235.48.133:5000/crm', // 'http://192.168.1.50:5000/crm', // 'http://13.235.48.133:5000/crm', // 
//     production: false
// };

export const environment = {
    apiUrl: 'https://demo-api.akashicsoft.in/crm',
    production: false
};

// export const environment = {
//     apiUrl: 'http://43.204.25.200:3420/crm', // 'http://api.akashicsoft.com/crm',  //'http://13.235.48.133:5000/crm', // 'http://192.168.1.50:5000/crm', // 'http://13.235.48.133:5000/crm', // 
//     production: false
// };

// export const environment = {
//   apiUrl: 'http://192.168.1.5:5000/crm',  //'http://13.235.48.133:5000/crm', // 'http://192.168.1.50:5000/crm', // 'http://13.235.48.133:5000/crm', // 
//   production: false
// };

// export const environment = {
//   apiUrl: 'http://43.204.25.200:3420/crm',  //'http://13.235.48.133:5000/crm', // 'http://192.168.1.50:5000/crm', // 'http://13.235.48.133:5000/crm', // 
//   production: false
// };

// export const environment = {
//   apiUrl:  'https://api.akashicsoft.com/crm', //'https://afc1-160-238-92-155.ngrok-free.app/crm', // 'http://192.168.1.50:5000/crm', // 'http://13.235.48.133:5000/crm', // 
//   production: false
// };

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
